import { Suspense } from "react";
import Routes from "./AppRoutes";
import { useSelector } from "react-redux";
import { ThemeProvider } from "@mui/material";
import theme from "../theme";
import "../assets/style.css";
import CustomSnackbar from "../components/common/CustomSnackbar";
import ApplyBlockedDialog from "../components/common/ApplyBlockedDialog";
import ForegroundNotificationToast from "../components/common/ForegroundNotificationToast";
import NotificationNavigateListener from "../components/common/NotificationNavigateListener";
import AuthWrapper from "./AuthWrapperAllTime";
import { initNotificationStore } from "../utils/notificationStore";

initNotificationStore();

const App = (): JSX.Element => {
  const userRole = useSelector((state: any) => state.app.userRole);

  return (
    <ThemeProvider theme={theme}>
      <Suspense fallback={<div>Loading ...</div>}>
        <AuthWrapper>
          <NotificationNavigateListener />
          <Routes userRole={userRole} />
        </AuthWrapper>
        <CustomSnackbar />
        <ApplyBlockedDialog />
        <ForegroundNotificationToast />
      </Suspense>
    </ThemeProvider>
  );
};

export default App;
